/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Secondary_School_Teaching29Inputs */

const en__field__enum_studyprograms_study_secondary_school_teaching29 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Secondary_School_Teaching29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secondary School Teaching`)
};

const de__field__enum_studyprograms_study_secondary_school_teaching29 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Secondary_School_Teaching29Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehramt für Gymnasien`)
};

/**
* | output |
* | --- |
* | "Secondary School Teaching" |
*
* @param {_Field__Enum_Studyprograms_Study_Secondary_School_Teaching29Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_secondary_school_teaching29 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Secondary_School_Teaching29Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Secondary_School_Teaching29Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_secondary_school_teaching29(inputs)
	return de__field__enum_studyprograms_study_secondary_school_teaching29(inputs)
});
export { _field__enum_studyprograms_study_secondary_school_teaching29 as "_field__enum_studyPrograms_STUDY_SECONDARY_SCHOOL_TEACHING" }